import { Tabs } from "@mantine/core";
import type { ReactNode } from "react";

import type { TabItem } from "../../config";

interface TabsProps {
  children?: ReactNode;
  tabs?: TabItem[];
}

/**
 * MarkdocTabs renders the {% tabs %} tag as Mantine `Tabs` for rich panel
 * bodies. The parent transform folds the `tabs` strip from the children, while
 * each {% tab %} renders its own `Tabs.Panel`.
 */
export const MarkdocTabs = ({ children, tabs = [] }: TabsProps) => {
  const [firstTab] = tabs;

  if (!firstTab) {
    return null;
  }

  return (
    <Tabs defaultValue={firstTab.value} my="md" variant="outline">
      <Tabs.List>
        {tabs.map((tab) => (
          <Tabs.Tab key={tab.value} value={tab.value}>
            {tab.label}
          </Tabs.Tab>
        ))}
      </Tabs.List>
      {children}
    </Tabs>
  );
};

interface TabProps {
  children?: ReactNode;
  value?: string;
}

/**
 * Tab renders one {% tab %} as a Mantine `Tabs.Panel`, keyed by the `value` the
 * parent {% tabs %} transform stamped so the panel pairs with its control.
 */
export const Tab = ({ children, value }: TabProps) => (
  <Tabs.Panel pt="sm" value={value ?? ""}>
    {children}
  </Tabs.Panel>
);
